/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpToolsRequest {
    getFixupPrototypeFunction() { return McpToolsRequest.fixupPrototype; }

    static newInstance(model: Partial<McpToolsRequest>): McpToolsRequest {
        let obj = Object.assign(new McpToolsRequest(), model);
        McpToolsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpToolsRequest>): McpToolsRequest {
        if (!model) return null;
        return McpToolsRequest.newInstance(<McpToolsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpToolsRequest) {
        if (!obj) return;

        models.McpToolsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpToolsRequest): boolean {
        Object.setPrototypeOf(obj, McpToolsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the tenant
     */
    tenant_id: string;

    /**
     * Business agent name used to scope the tool list.
     */
    business_agent: models.Agents;

}
